<template>
  <div class="root">
    <div class="line" :style="{'borderColor':borderColor}"></div>
  </div>
</template>

<script>
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: 'rgb(151, 151, 151)',
    };
  },
  mounted(){
    const node = this.getNode();
    node.on('change:data',(res)=>{
      console.log("数据发生改变",res)
      this.borderColor = res.current.borderColor;
    })
  }
}
</script>

<style scoped>
  .root{
    height: 100%;
    height: 100%;
    /* background-color: aqua; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .line{
    height: 100%;
    width: 0px;
    border: 1px dashed rgb(151, 151, 151);
    position: absolute;
    /* animation: scroll 6s linear infinite normal; */
  }
</style>